module.exports = __webpack_public_path__ + "static/media/will-skidmore-bluffs.0a45f8d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/will-skidmore-bluffs.jpg
// module id = 88
// module chunks = 0